export default "__VITE_ASSET__Ch4zaTxq__"